import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, APP_INITIALIZER } from '@angular/core';
import { provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { TitleService } from './services/title.service';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withPreloading(PreloadAllModules) // Preload all lazy-loaded modules after initial load
    ),
    provideHttpClient(),
    {
      provide: APP_INITIALIZER,
      useFactory: (titleService: TitleService) => () => titleService,
      deps: [TitleService],
      multi: true
    }
  ]
};
